import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './index.css';

const Auth = ({ onLogin }) => {
  // 登录状态
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  // 注册状态
  const [regUsername, setRegUsername] = useState('');
  const [regNickname, setRegNickname] = useState('');
  const [regPassword, setRegPassword] = useState('');
  const [regConfirmPwd, setRegConfirmPwd] = useState('');
  // 切换登录/注册
  const [isLogin, setIsLogin] = useState(true);
  const navigate = useNavigate();

  // 从 localStorage 获取用户列表
  const getUsers = () => {
    return JSON.parse(localStorage.getItem('blogUsers') || '[]');
  };

  // 登录提交
  const handleLoginSubmit = (e) => {
    e.preventDefault();
    if (!username || !password) {
      alert('请输入用户名和密码！');
      return;
    }
    // 验证用户（作业模拟：存在即登录，无则提示注册）
    const users = getUsers();
    const user = users.find(u => u.username === username && u.password === password);
    if (user) {
      onLogin({ username: user.username, nickname: user.nickname });
      alert('登录成功！');
      navigate('/'); // 登录后跳首页
    } else {
      alert('用户不存在，请先注册！');
      setIsLogin(false); // 自动切换到注册页
    }
  };

  // 注册提交
  const handleRegisterSubmit = (e) => {
    e.preventDefault();
    // 表单校验
    if (!regUsername || !regNickname || !regPassword || !regConfirmPwd) {
      alert('请填写所有注册信息！');
      return;
    }
    if (regPassword !== regConfirmPwd) {
      alert('两次密码输入不一致！');
      return;
    }
    // 检查用户名是否重复
    const users = getUsers();
    if (users.some(u => u.username === regUsername)) {
      alert('用户名已存在，请更换！');
      return;
    }
    // 保存新用户
    const newUser = { username: regUsername, nickname: regNickname, password: regPassword };
    users.push(newUser);
    localStorage.setItem('blogUsers', JSON.stringify(users));
    alert('注册成功！请登录');
    // 切换到登录页并回填用户名
    setIsLogin(true);
    setUsername(regUsername);
    setPassword('');
    setRegUsername('');
    setRegNickname('');
    setRegPassword('');
    setRegConfirmPwd('');
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2 className="auth-title">
          {isLogin ? '欢迎登录我的博客' : '账号注册'}
        </h2>

        {/* 登录表单 */}
        {isLogin && (
          <form onSubmit={handleLoginSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="username">用户名</label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="请输入用户名"
                className="form-input"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">密码</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="请输入密码"
                className="form-input"
                required
              />
            </div>
            <button type="submit" className="auth-btn login-btn">登录</button>
          </form>
        )}

        {/* 注册表单 */}
        {!isLogin && (
          <form onSubmit={handleRegisterSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="reg-username">用户名</label>
              <input
                type="text"
                id="reg-username"
                value={regUsername}
                onChange={(e) => setRegUsername(e.target.value)}
                placeholder="请设置用户名"
                className="form-input"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="reg-nickname">昵称</label>
              <input
                type="text"
                id="reg-nickname"
                value={regNickname}
                onChange={(e) => setRegNickname(e.target.value)}
                placeholder="请设置昵称"
                className="form-input"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="reg-password">密码</label>
              <input
                type="password"
                id="reg-password"
                value={regPassword}
                onChange={(e) => setRegPassword(e.target.value)}
                placeholder="请设置密码"
                className="form-input"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="reg-confirm-pwd">确认密码</label>
              <input
                type="password"
                id="reg-confirm-pwd"
                value={regConfirmPwd}
                onChange={(e) => setRegConfirmPwd(e.target.value)}
                placeholder="请再次输入密码"
                className="form-input"
                required
              />
            </div>
            <button type="submit" className="auth-btn reg-btn">注册</button>
          </form>
        )}

        {/* 切换登录/注册 */}
        <p className="auth-switch">
          {isLogin ? (
            <>
              还没有账号？
              <span onClick={() => setIsLogin(false)} className="switch-link">立即注册</span>
            </>
          ) : (
            <>
              已有账号？
              <span onClick={() => setIsLogin(true)} className="switch-link">立即登录</span>
            </>
          )}
        </p>
        <p className="auth-tip">作业测试：注册后即可登录</p>
      </div>
    </div>
  );
};

export default Auth;